module.exports = __webpack_public_path__ + "static/media/kazue_otsuki_600x600.b4a67df3.jpg";